/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { fragment } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import type DexResponse from 'linced-app/models/enrolments/nz-moe/dex-response';
import type Status from 'linced-app/models/enrolments/status';
import type Person from 'linced-app/models/person';
import type School from 'linced-app/models/school';

// Proto: enrolments.AttendanceSurvey.
export default class AttendanceSurvey extends Model {
  declare [Type]: 'enrolments/attendance-survey';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @belongsTo('enrolments/status', { async: true, inverse: null })
  declare statusId: AsyncBelongsTo<Status>;

  @alias('statusId')
  declare status: AsyncBelongsTo<Status>;

  @alias('status.id')
  declare status_id: string | null | undefined;

  @alias('status.status')
  declare state: unknown;

  @belongsTo('person', { async: true, inverse: null })
  declare requesterId: AsyncBelongsTo<Person>;

  @alias('requesterId')
  declare requester: AsyncBelongsTo<Person>;

  @attr('number', { defaultValue: 0 })
  declare jurisdiction: EnumValue<typeof Jurisdiction> | 0;

  // fromDate is the start date of the period this survey covers, in YYYY-MM-DD format.
  @attr('string')
  declare fromDate: string | undefined;

  // toDate is the end date of the period this survey covers, in YYYY-MM-DD format.
  @attr('string')
  declare toDate: string | undefined;

  // surveyContent is the content of the attendance survey (CSV) to be uploaded.
  @attr('string', { defaultValue: '' })
  declare surveyContent: string;

  @fragment('enrolments/nz-moe/dex-response')
  declare nzMoe: DexResponse | null;

  @alias('nzMoe.dexCode')
  declare dexCode: unknown;

  @alias('nzMoe.dexInfo')
  declare dexInfo: unknown;
}
